"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var AdditionalSupportRecordEntry_1 = require("./AdditionalSupportRecordEntry");
var VulnerableCustomerHistoryGrid = /** @class */ (function (_super) {
    __extends(VulnerableCustomerHistoryGrid, _super);
    function VulnerableCustomerHistoryGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VulnerableCustomerHistoryGrid.prototype.render = function () {
        return this.props.additionalSupportRecords && this.props.additionalSupportRecords.count > 0 && ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "vc-additional-support-panel", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-white", children: "Additional support history" }), this.renderHistoryRecordEntries()] }) }));
    };
    VulnerableCustomerHistoryGrid.prototype.renderHistoryRecordEntries = function () {
        return this.props.additionalSupportRecords.results.map(function (additionalSupportRecord, index) {
            return (0, jsx_runtime_1.jsx)(AdditionalSupportRecordEntry_1.AdditionalSupportRecordEntry, { additionalSupportRecord: additionalSupportRecord }, index);
        });
    };
    VulnerableCustomerHistoryGrid = __decorate([
        components_1.authorize
    ], VulnerableCustomerHistoryGrid);
    return VulnerableCustomerHistoryGrid;
}(React.Component));
exports.default = VulnerableCustomerHistoryGrid;
//# sourceMappingURL=VulnerableCustomerHistoryGrid.js.map